<div style="
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    z-index: 999999;
    padding-top: 25%;
    background-color: rgba(244, 244, 244, 0.5);
  "> 
  <img class="rounded mx-auto d-block" src="./assets/img/tire.gif" />
  <p style="
      color: black;
      font-weight: bolder;
      font-size: 18px;
      width: 200px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    ">
    {{message}}
  </p>
</div>
